/* global document */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import axios from 'axios';
import * as Cookies from 'js-cookie';
import moment from 'moment';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

axios.defaults.withCredentials = true;
const csrftoken = Cookies.get('csrftoken');
if (csrftoken) axios.defaults.headers.common['X-CSRFToken'] = csrftoken;

moment.defaultFormat = 'YYYY-MM-DD';

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js